import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Join.css";
import htmlParser from 'html-react-parser';
import MediaQuery from "react-responsive";

export default function Join({ joinData,links }) {
  return (
    <>
      <div className="join">
        <Container>
          
            <Col>
              <MediaQuery maxWidth={991}>
                <div className="join-section-desktop">
                  <p className="date-time-desktop mb-5">
                    Thank you, Build Your Empire, for such an electrifying event.
                    <br />Let's continue to push the boundaries of what is possible in the mortgage industry with {links.brandName}'s revolution.
                  </p>
                </div>
              </MediaQuery>
            </Col>
            <Col>
              <MediaQuery minWidth={992}>
                <div className="join-section-desktop">
                  <p className="date-time-desktop mb-5">
                    Thank you, Build Your Empire, for such an electrifying event.
                    <br />Let's continue to push the boundaries of what is possible in the mortgage industry with {links.brandName}'s revolution.
                  </p>
                </div>
              </MediaQuery>
            </Col>
          
        </Container>
      </div>
    </>
  );
}
